import {$host} from "./index";

export const fetchNews = async (title, author, content, page) => {
    const {data} = await $host.get('news/', { params: {title, author, content, page}})
    return data
}

export const createNew = async (title, author, content) => {
    const {data} = await $host.post('news/', { title, author, content })
    return data
}

export const deleteNew = async (id) => {
    const {data} = await $host.delete('news/' + `${id}`)
    return data
}
export const updateNew = async (id, title, author, content) => {
    const {data} = await $host.patch('news/' + `${id}`, { title, author, content })
    return data
}